import classNames from 'classnames';
import * as Flowbite from 'flowbite-react';
import { IconDots } from '@tabler/icons-react';
import { dropdownTheme } from 'shared/Input/Combo/theme';
import { BaseInputProps } from 'shared/Input/types';
import { getReplaceThemeProps } from 'utils/replaceTheme';
import { theme } from '../Text/theme';

type ComboSelectProps = BaseInputProps & {
    options: { label: string; value: string }[];
    dropdownTitle?: string;
};

export const Combo = ({
    onChange = () => {},
    options = [],
    className,
    label,
    dropdownTitle,
    color = 'primary',
    ...props
}: ComboSelectProps) => {
    const locked = props.disabled || props.readOnly;
    const includeDropdown = !locked && options.length > 0;

    return (
        <Flowbite.Label
            className="flex flex-col gap-2 font-normal"
            color={color}
        >
            {label && <span className="font-medium">{label}</span>}

            <div className="flex relative">
                <Flowbite.TextInput
                    className={classNames('grow', className, {
                        '[&_input]:rounded-r-none': includeDropdown,
                        '[&_input]:border-r-0': includeDropdown,
                    })}
                    {...props}
                    {...getReplaceThemeProps(theme)}
                    color={color}
                    onChange={(e) => onChange(e.target.value)}
                />

                {includeDropdown && (
                    <Flowbite.Dropdown
                        {...getReplaceThemeProps(dropdownTheme)}
                        title={dropdownTitle}
                        label={<IconDots size={24} />}
                        arrowIcon={false}
                        placement="bottom-end"
                        className="w-full max-h-96 overflow-auto"
                    >
                        {options.map((option) => (
                            <Flowbite.DropdownItem
                                key={option.value}
                                onClick={() => onChange(option.value)}
                                className="text-wrap"
                            >
                                {option.label}
                            </Flowbite.DropdownItem>
                        ))}
                    </Flowbite.Dropdown>
                )}
            </div>
        </Flowbite.Label>
    );
};
